import { faDownload, faFile, faFilePdf, faVideo } from "@fortawesome/free-solid-svg-icons";
import { faMaximize } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import React, { ReactNode } from "react";
import Helper from "../../Helper";
import CardButton from "./CardButton";
import Modal from "./Modal";
import Tooltip from "./Tooltip";

interface Props {
    content_type: string;
    uri: string;
    downloadURI?: string;
    filename: string;
    iconSize?: number;
}

interface State {
    previewOpen: boolean;
}

class FilePreview extends React.Component<Props, State> {
    supportedFileTypes = [
        "image/jpeg",
        "image/png",
        "image/svg+xml",
        "image/webp",
        "image/bmp",
        "image/ico",
        "application/pdf",
    ];

    state: Readonly<State> = { previewOpen: false };

    constructor(props) {
        super(props);
    }

    renderImage = (icon: boolean = false): ReactNode => {
        return (
            <div>
                <img
                    src={this.props.uri}
                    className={Helper.classNames(icon ? "ml-auto mr-auto object-cover" : "w-full")}
                    style={{
                        minWidth: icon ? (this.props.iconSize ? this.props.iconSize : "64") + "px" : "0",
                        minHeight: icon ? (this.props.iconSize ? this.props.iconSize : "64") + "px" : "0",
                        maxWidth: icon ? (this.props.iconSize ? this.props.iconSize : "64") + "px" : "none",
                        maxHeight: icon ? (this.props.iconSize ? this.props.iconSize : "64") + "px" : "none",
                    }}
                />
            </div>
        );
    };

    isViewableImage = (content_type: string): boolean => {
        return ["jpg", "jpeg", "png", "gif", "svg"].some((ext) => content_type.includes(ext));
    };

    isViewableFileType = (content_type: string): boolean => {
        if (this.isViewableImage(content_type)) {
            return true;
        }
        return this.supportedFileTypes.some((e) => e === content_type);
    };

    fileThumbnailIcon = (content_type) => {
        if (content_type.startsWith("image")) {
            return <FontAwesomeIcon icon={faVideo} />;
        }
        if (content_type === "application/pdf") {
            return <FontAwesomeIcon icon={faFilePdf} />;
        } else {
            return <FontAwesomeIcon icon={faFile} />;
        }
    };

    renderViewableFile = () => {
        if (this.isViewableImage(this.props.content_type)) {
            return this.renderImage(false);
        }

        return (
            <object
                width="100%"
                height="400"
                data="https://gc.getplot.dev/projects/7fe411c04d8a9ad9291c/deliveries/760a2968e296c309b69f/attachments/86/show_file"
                type="application/pdf"
            >
                {" "}
            </object>
        );

        // return <embed src={this.props.uri + "#toolbar=0"} className="w-full h-[500px]" />;
    };

    render() {
        const { previewOpen } = this.state;

        return (
            <>
                <Tooltip title={this.props.filename}>
                    <CardButton
                        onClick={() => this.setState({ previewOpen: true })}
                        className="hover:bg-gray-200 h-24 w-full overflow-hidden"
                    >
                        <div className="flex flex-row gap-2 items-center justify-between w-full">
                            <div className="w-1/2 mx-auto px-2">
                                {this.isViewableImage(this.props.content_type) ? (
                                    <img
                                        className="object-cover rounded-lg w-full h-full"
                                        src={this.props.uri}
                                        alt={this.props.filename}
                                    />
                                ) : (
                                    <FontAwesomeIcon
                                        icon={Helper.fileTypeIconHelper(this.props.content_type)}
                                        size="2xl"
                                        color={Helper.fileTypeColorHelper(this.props.content_type)}
                                    />
                                )}
                            </div>
                            <div className="flex flex-col items-start gap-1 w-2/3">
                                <div className="font-medium text-xs text-gray-900 dark:text-neutral-100 truncate text-left">
                                    {this.props.filename}
                                </div>
                                <div className="text-sm text-gray-500 uppercase">{this.props.content_type}</div>
                            </div>
                        </div>
                    </CardButton>
                </Tooltip>

                <Modal
                    title={"File Preview: " + this.props.filename}
                    open={previewOpen}
                    onCancel={() => this.setState({ previewOpen: false })}
                    footer={null}
                >
                    {this.isViewableFileType(this.props.content_type) ? (
                        this.renderViewableFile()
                    ) : (
                        <div className="mt-4">
                            <p className="text-center">No Preview Available (Download to View)</p>
                        </div>
                    )}
                    <div className="flex flex-row-reverse mt-2 gap-4">
                        {this.isViewableFileType(this.props.content_type) && (
                            <button
                                type="button"
                                className="hover:cursor-pointer"
                                onClick={() => window.open(this.props.uri, "_blank")}
                            >
                                <FontAwesomeIcon icon={faMaximize} size="2xl" />
                            </button>
                        )}
                        {this.props.downloadURI && (
                            <button
                                type="button"
                                className="hover:cursor-pointer"
                                onClick={() => window.open(this.props.downloadURI, "_blank")}
                            >
                                <FontAwesomeIcon icon={faDownload} size="2xl" />
                            </button>
                        )}
                    </div>
                </Modal>
            </>
        );
    }
}

export default FilePreview;
